import React from "react";
import request from "arcdynamic-request";
import {SELLERS} from "../../consts/tables";
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { ApolloConsumer } from "@apollo/client";
import filter from "../../filter";
import { GET_SELLERS } from "../Graphql/Queries/SellersQuery";
import { fetchData } from "../Service/graphQlService";
import { GET_BUYER_DD_QUERY, GET_CONTACT_SELLERS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";

const cloneDeep = require("lodash.clonedeep");

class SelectSeller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
        };
        this.client = null
    }
    
    componentDidMount() {
        this.fetch(0);
    }


    fetch(offset) {
        this.setState({ isBusy: true });

		// const query = { ...offset };
		// const options = filter(query, 'sellers');
		// options.param.limit = limit;
		// options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        let page = offset + 1;
        var limit = 5000*page;
        var pageParams = {
			page: page,
			pageSize: 5000
		}
        const sortOptions = [
            {
                "field": "first_name",
                "order": "asc"
              },
               {
                "field": "last_name",
                "order": "asc"
              },
               {
                "field": "company_name",
                "order": "asc"
              }
          ]
        // const limit =  {  count: limit,
        //                     offset: offset * limit,  }
    //    const  column =  ["ARCIMEDES_ROW_ID",
    //                                             "FIRST_NAME",
    //                                             "LAST_NAME",
    //                                             "COMPANY_NAME", ]
    //    const filter = [  { code: "DELETED", text: "", type: "null", },]
    //    const order: [
    //                     {
    //                         code: "FIRST_NAME",
    //                         type: "asc",
    //                     },
    //                     {
    //                         code: "LAST_NAME",
    //                         type: "asc",
    //                     },
    //                     {
    //                         code: "COMPANY_NAME",
    //                         type: "asc",
    //                     },
    //                 ],
        const token = localStorage.getItem('authToken');
		// const sortOptions = this.parseSortOptions(q.order);
        // const filterOptions = this.parseFilterOptions(q); 
        // request(arc.path.api, {
        //     service: "arcimedes",
        //     action: "open.datasource.table.Data.getData",
        //     // variable:{filters:[deleted:""] sortOptions:[first_N]}
        //     params: [
        //         "code",
        //         SELLERS,
        //         {
        //             limit: {
        //                 count: limit,
        //                 offset: offset * limit,
        //             },
        //             column: [
        //                 "ARCIMEDES_ROW_ID",
        //                 "FIRST_NAME",
        //                 "LAST_NAME",
        //                 "COMPANY_NAME",
        //             ],
        //             filterType: "and",
        //             filter: [
        //                 {
        //                     code: "DELETED",
        //                     text: "",
        //                     type: "null",
        //                 },
        //             ],
        //             order: [
        //                 {
        //                     code: "FIRST_NAME",
        //                     type: "asc",
        //                 },
        //                 {
        //                     code: "LAST_NAME",
        //                     type: "asc",
        //                 },
        //                 {
        //                     code: "COMPANY_NAME",
        //                     type: "asc",
        //                 },
        //             ],
        //         },
        //     ],
        // })
        if (this.client && token) {
            // this.client.query({
            //     query: GET_SELLERS, variables: { pageOptions: pageParams}, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // })
            fetchData(GET_BUYER_DD_QUERY, {type: "Investor",pageOptions: pageParams, sortOptions: sortOptions })
        .then((res) => {
            this.setState((prevState) => {
                var data = res.data.getContacts.data.filter(item => item.first_name !== '' || item.last_name !== '' || item.company_name !== '');
                data = data.filter(item => {
                    const firstName = item.first_name !== null && item.first_name !== undefined ? item.first_name.trim() : "";
                    const lastName = item.last_name !== null && item.last_name !== undefined ? item.last_name.trim() : "";
                    
                    return firstName !== "" && lastName !== "";
                  });
                //data = data.filter(x => x.company_name != null) // added to avoid Seller DD issue in Ownership Tab
                const items = prevState.items.concat(data);

                return {
                    items,
                };
            });
            // if (res.data.getSellers.data >= limit) {
            //     this.fetch(++offset);
            // }
            if (res.data.getContacts.totalCount >= limit) {
                this.fetch(++offset);
            }
        });
     }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newSeller !== nextProps.newSeller) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newSeller);
            this.setState({items});
        }
    }

    render() {
        const {items} = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            handleParentChange,
            addNewItem,
            deleted,
            viewMode,
            ...rest
        } = this.props;

        return (
            <ApolloConsumer>
            {client => {
              if(!this.client){
                this.client = client
              }
              return(
            <Dropdown
                theme={theme}
                optionsType="seller"
                optionKey="contact_id"
                options={items}
                value={value}
                valueKey={valueKey}
                label={label}
                disabled={!items || disabled}
                data={data}
                withAddNew={withAddNew}
                handleParentChange={handleParentChange}
                addNewItem={addNewItem}
                deleted={deleted}
                viewMode={viewMode}
                {...rest}
            />
        )
    }}
  </ApolloConsumer>
        );
    }
}

SelectSeller.propTypes = {
    theme: PropTypes.oneOf(["default", "white", "dark"]),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectSeller;



// import React from "react";
// import request from "arcdynamic-request";
// import {SELLERS} from "../../consts/tables";
// import Dropdown from "../Dropdown/Dropdown";
// import PropTypes from "prop-types";
 
// const cloneDeep = require("lodash.clonedeep");
// const limit = 1000;
 
// class SelectSeller extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             items: [],
//         };
//     }
 
//     componentDidMount() {
//         this.fetch(0);
//     }
 
//     fetch(offset) {
//         request(arc.path.api, {
//             service: "arcimedes",
//             action: "open.datasource.table.Data.getData",
//             params: [
//                 "code",
//                 SELLERS,
//                 {
//                     limit: {
//                         count: limit,
//                         offset: offset * limit,
//                     },
//                     column: [
//                         "ARCIMEDES_ROW_ID",
//                         "FIRST_NAME",
//                         "LAST_NAME",
//                         "COMPANY_NAME",
//                     ],
//                     filterType: "and",
//                     filter: [
//                         {
//                             code: "DELETED",
//                             text: "",
//                             type: "null",
//                         },
//                     ],
//                     order: [
//                         {
//                             code: "FIRST_NAME",
//                             type: "asc",
//                         },
//                         {
//                             code: "LAST_NAME",
//                             type: "asc",
//                         },
//                         {
//                             code: "COMPANY_NAME",
//                             type: "asc",
//                         },
//                     ],
//                 },
//             ],
//         }).then((res) => {
//             this.setState((prevState) => {
//                 const data = res.data.filter(item => item.FIRST_NAME !== '' || item.LAST_NAME !== '' || item.COMPANY_NAME !== '')
//                 const items = prevState.items.concat(data);
 
//                 return {
//                     items,
//                 };
//             });
//             if (res.data.length >= limit) {
//                 this.fetch(++offset);
//             }
//         });
//     }
 
//     componentWillReceiveProps(nextProps) {
//         if (this.props.newSeller !== nextProps.newSeller) {
//             const items = cloneDeep(this.state.items);
//             items.push(nextProps.newSeller);
//             this.setState({items});
//         }
//     }
 
//     render() {
//         const {items} = this.state;
//         const {
//             theme,
//             value,
//             valueKey,
//             label,
//             disabled,
//             data,
//             withAddNew,
//             handleParentChange,
//             addNewItem,
//             deleted,
//             viewMode,
//             ...rest
//         } = this.props;
 
//         return (
//             <Dropdown
//                 theme={theme}
//                 optionsType="seller"
//                 optionKey="ARCIMEDES_ROW_ID"
//                 options={items}
//                 value={value}
//                 valueKey={valueKey}
//                 label={label}
//                 disabled={!items || disabled}
//                 data={data}
//                 withAddNew={withAddNew}
//                 handleParentChange={handleParentChange}
//                 addNewItem={addNewItem}
//                 deleted={deleted}
//                 viewMode={viewMode}
//                 {...rest}
//             />
//         );
//     }
// }
 
// SelectSeller.propTypes = {
//     theme: PropTypes.oneOf(["default", "white", "dark"]),
//     value: PropTypes.string,
//     valueKey: PropTypes.string.isRequired,
//     label: PropTypes.string,
//     disabled: PropTypes.bool,
//     data: PropTypes.object,
//     withAddNew: PropTypes.bool,
//     handleParentChange: PropTypes.func.isRequired,
//     viewMode: PropTypes.bool,
//     addNewItem: PropTypes.func,
//     deleted: PropTypes.bool,
//     isFromProperty: PropTypes.bool,
// };
 
// export default SelectSeller;